import { ZUid } from "src/types/zUid";
import { ZStateReqAttributes } from "./RequiredAttributes.types";

export type EdReqAttributes = Omit<ZStateReqAttributes, "stateId">;
export type EdReqAttributesDict = Record<ZUid, EdReqAttributes>;

export const reqAttrs2ed = (
  list: ZStateReqAttributes[],
): EdReqAttributesDict => {
  const dict: EdReqAttributesDict = {};
  list.forEach(({ stateId, ...rest }) => {
    dict[stateId] = rest;
  });
  return dict;
};

export const ed2reqAttrs = (dict: EdReqAttributesDict): ZStateReqAttributes[] =>
  Object.entries(dict).map(([stateId, t]: [string, EdReqAttributes]) => ({
    stateId,
    ...t,
  }));
